import { createStore, createHook, type Action } from '@atlassian/react-sweet-state';
import type { AdminPageSidebar, SidebarState } from './types';

const initialState: SidebarState = {
	sidebarContent: null,
};

const actions = {
	setSidebarContent:
		(sidebarContent: AdminPageSidebar): Action<SidebarState> =>
		({ setState }) =>
			setState({ sidebarContent }),
	closeSidebar:
		(): Action<SidebarState> =>
		({ setState }) =>
			setState({ sidebarContent: null }),
};

const Store = createStore<SidebarState, typeof actions>({
	initialState,
	actions,
	name: 'AdminPageSidebarStore',
});

const useHook = createHook(Store);

export const useAdminPageSidebar = () => {
	const [state, hookActions] = useHook();
	return {
		state,
		...hookActions,
	};
};
